import React, { useState } from 'react';
import { Empty, Segmented } from 'antd';
import EvalAnalyticsPage from '../../pages/EvalAnalyticsPage';
import EvalAgentStatsPage from '../../pages/EvalAgentStatsPage';
import EvalInsightsPage from '../../pages/EvalInsightsPage';
import WindowNote from './WindowNote';

/**
 * Evaluations for the campaign, rendered by the pages that already compute
 * them: Analytics (scores, sections, questions) and Agent Stats (by agent),
 * one at a time behind a toggle rather than as two Campaign Summary tabs.
 *
 * The Campaign Summary is a hub: rather than a second query for the same
 * numbers, this scopes the existing pages to the chosen campaign and window.
 * A fix there lands here, and the two cannot drift into disagreeing.
 */
export default function EvaluationsTab({ campaignId, from, to, skills }) {
  const [view, setView] = useState('analytics');
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <Segmented
        value={view}
        onChange={setView}
        style={{ marginBottom: 16 }}
        options={[
          { label: 'Analytics',   value: 'analytics' },
          { label: 'Agent Stats', value: 'agents' },
          { label: 'Insights',    value: 'insights' },
        ]}
      />
      {view === 'analytics' && <EvalAnalyticsPage embedded campaignId={campaignId} from={from} to={to} skills={skills} />}
      {view === 'agents'    && <EvalAgentStatsPage embedded campaignId={campaignId} from={from} to={to} skills={skills} />}
      {view === 'insights'  && <EvalInsightsPage embedded campaignId={campaignId} from={from} to={to} skills={skills} />}
    </>
  );
}
